import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Grid } from '@mui/material';

const VerificationsSummary = ({ verifications }) => {
  const { t } = useTranslation();

  const getEntityName = useCallback(() => {
    return Object.entries(
      verifications.reduce((occ, o) => {
        occ[o.entityName] = (occ[o.entityName] || 0) + 1;
        return occ;
      }, {})
    );
  }, [verifications]);

  const getStatus = useCallback(() => {
    return Object.entries(
      verifications.reduce((occ, o) => {
        occ[o.statusName] = (occ[o.statusName] || 0) + 1;
        return occ;
      }, {})
    );
  }, [verifications]);

  return (
    <div>
      <Typography variant='h6'>{t('Offer.Edit.Verifications.Title')}</Typography>
      {getEntityName().map((entity, index) => {
        return (
          <Grid container key={index}>
            <Grid item xs={12} sm={2} md={4}>
              {t('Offer.Edit.Verifications.Header', {
                entityName: entity[0],
                entityNumber: entity[1]
              })}
            </Grid>
            {getStatus().map((status, idx) => {
              return (
                <Grid item xs={12} sm={2} md={2} key={idx}>
                  {status[0]} : <span>{status[1]}</span>
                </Grid>
              );
            })}
          </Grid>
        );
      })}
    </div>
  );
};

VerificationsSummary.propTypes = {
  verifications: PropTypes.array
};

export default VerificationsSummary;
